import styled from "styled-components";
import { CloseBlueIcon } from "../../../assets/icons/Icons";

const Container = styled.div`
  margin-bottom: 48px;
`;

const Title = styled.p`
  color: var(--neutrals-charcoal);
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
`;

const Property = styled.p`
  color: var(--neutrals-charcoal);
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 16px;
`;

const FilesContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 5px;
    grid-row-gap: 20px;
    @media only screen and (max-width: 769px) {
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 5px;
      grid-row-gap: 20px;
    }
    @media only screen and (max-width: 426px) {
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 5px;
      grid-row-gap: 20px;
    }
`;

const DocButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid var(--secondary-maya-blue);
  background-color: var(--secondary-alice-blue);
  padding: 4px 14px 4px 4px;
  border-radius: 32px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--primary-royal-blue);
  font-size: 12px;
  transition: 300ms;
  text-decoration: underline;
  font-weight: 600;
  max-width: 200px;
  & svg {
    width: 22px;
    height: 22px;
  }
  &:hover {
    opacity: 0.8;
  }
  .overflow-ellipsis {
    text-overflow: ellipsis;
  }
  p {
    width: 190px;
    white-space: nowrap;
    overflow: hidden;
  }
`;
export const SeguimientoCard = ({ date, note, files }) => {
const getName = (name) => {
  const extension = name?.split(".").pop();
  const nameWithoutExtension = name?.slice(0, -4);
  const newName = nameWithoutExtension?.slice(0, 25);
  return name?.length < 30 ? name : newName + "... ." + extension;
};
  return (
    <Container>
      <Title>Seguimiento {date}</Title>
      <Property>
        <b>Notas de seguimiento:</b> {note}
      </Property>
      {files.length > 0 ? (
        <Property>
          <b>Documentales:</b>
        </Property>
      ) : (
        <></>
      )}

      <FilesContainer>
        {files.map((item, i) => (
          <DocButton key={i}>
            <CloseBlueIcon />
            <a
              href={item?.url}
              target="_blank"
              rel="noreferrer"
              className="overflow-ellipsis"
            >
              {getName(item?.nombre_archivo)}
            </a>
          </DocButton>
        ))}
      </FilesContainer>
    </Container>
  );
};
